import { render, staticRenderFns } from "./ElementGatewayProperties.vue?vue&type=template&id=5850e88d"
import script from "./ElementGatewayProperties.vue?vue&type=script&lang=js"
export * from "./ElementGatewayProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports